/**
 * Module « Bienvenue » (C13) — la page qui explique le CRM à quelqu'un qui
 * l'ouvre pour la première fois.
 *
 * `sansNav` + `lienPied` : une page qu'on lit une fois et qu'on rouvre
 * rarement n'a pas sa place dans la barre de navigation, où elle prendrait le
 * rang d'un module de travail ; elle vit dans le pied, à côté de la
 * déconnexion. L'invariant du registre REFUSE `lienPied` sans `sansNav`.
 *
 * `accueil` : tant que la personne n'a pas dit « J'ai compris », l'entrée dans
 * le CRM passe par ici. Une panne du journal ne ferme jamais la porte — le
 * noyau borne la question à 5 s et ouvre l'accueil normal en cas d'échec
 * (`core/accueil.ts`).
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";
import { lireEtat } from "./api";

const mod: ModuleDef = {
  id: "bienvenue",
  label: "Bienvenue",
  icon: "i-sparkles",
  navGroup: "ressources",
  navOrder: 90,
  rolesRequis: [],
  sansNav: true,
  lienPied: true,
  routes: [{ path: "/bienvenue", component: lazy(() => import("./routes/Index")) }],
  accueil: {
    queryKey: ["bienvenue", "etat"],
    queryFn: async () => ((await lireEtat()).comprisLe ? null : "/bienvenue"),
  },
};

export default mod;
